// react-bootstrap imports
import { useState } from "react"

// assets imports
import imgLua from "assets/Lua.png"

function Chat()
{
    return (
        <div className="container-lua-chat d-flex flex-column">
            <div className="container bg-white border border-2 border-dark rounded-2 position-relative p-1">
                <b>Olá!</b> <br /> Eu sou a inteligência artificial do LUA e ainda estou em desenvolvimento.<br />Terei mais funções em breve!
            </div>
        </div>
    )
}

export default function Lua()
{
    const luaStyle = "container-lua d-flex flex-column"
    const [showChat, setShowChat] = useState(false)

    return (
        <>
            <div className={luaStyle} onMouseOver={() => {setShowChat(true)}} onMouseOut={() => {setShowChat(false)}} >
                <img className="align-self-end" src={imgLua} width="50px" height="44px" alt="logo" />
            </div>
            {showChat ? <Chat /> : <></>}
        </>
    )
}